export default __webpack_public_path__ + "static/activities_image_two_mobile-fb97c626f18ba519ddac0b6c5345ef77.jpg";